import { useFormContext } from "react-hook-form";
import {
  DatePicker,
  InputText,
  InputTextArea,
  PriceInput,
  RadioInput,
  SelectField,
} from "../../components";

function DamageDetails() {
  const { control, watch } = useFormContext();

  const [
    mattress_stained_damaged = "",
    protector_damage = "",
    product_type = "",
  ] = watch([
    "damageInfo.mattress_stained_damaged",
    "damageInfo.protector_damage",
    "damageInfo.product_type",
  ]);

  return (
    <div className="space-y-3">
      <DatePicker
        control={control}
        name="damageInfo.date_incident"
        required
        label="Date of Incident"
      />
      <SelectField
        control={control}
        label="Product Type"
        required
        options={[
          { label: "Protector", value: "Protector" },
          { label: "Encasement", value: "Encasement" },
          { label: "Sheets", value: "Sheets" },
          { label: "Blanket", value: "Blanket" },
          { label: "Pillow", value: "Pillow" },
        ]}
        name="damageInfo.product_type"
      />
      <RadioInput
        control={control}
        label="Did you clean the product?"
        name="damageInfo.did_clean_product"
        options={["Yes", "No"]}
        required
      />

      {["Protector", "Encasement"].includes(product_type) && (
        <div className="bg-[#F3F8FE] bg-opacity-80 p-3 rounded-lg border border-blue-300 grid gap-y-3">
          <RadioInput
            control={control}
            name="damageInfo.protector_damage"
            required
            // shouldUnregister
            label="Protector/Encasement Stained/Damaged"
            options={["Yes", "No"]}
          />
          {protector_damage?.toLowerCase() === "yes" && (
            <SelectField
              control={control}
              name="damageInfo.damage_Protector_type"
              required
              // shouldUnregister
              label="Type of Stain/Damage(Protector)"
              options={[
                { label: "bed bugs", value: "bed bugs" },
                { label: "beverage", value: "beverage" },
                { label: "blood", value: "blood" },
                {
                  label: "bodily fluid or feces",
                  value: "bodily fluid or feces",
                },
                { label: "bunching", value: "bunching" },
                { label: "burn", value: "burn" },
                {
                  label: "does not fit properly",
                  value: "does not fit properly",
                },
                { label: "feces", value: "feces" },
                { label: "flaking", value: "flaking" },
                { label: "food", value: "food" },
                { label: "grease", value: "grease" },
                { label: "gum", value: "gum" },
                { label: "ink", value: "ink" },
                { label: "melted", value: "melted" },
                { label: "mildew", value: "mildew" },
                { label: "mold", value: "mold" },
                { label: "nail polish", value: "nail polish" },
                { label: "not cooling", value: "not cooling" },
                { label: "Peeling", value: "Peeling" },
                { label: "pet damage", value: "pet damage" },
                { label: "piling", value: "piling" },
                { label: "Rip or Tear", value: "Rip or Tear" },
                { label: "unknown stain", value: "unknown stain" },
                { label: "water", value: "water" },
                { label: "wearing", value: "wearing" },
                { label: "wine", value: "wine" },
                { label: "bleach", value: "bleach" },
                { label: "broken zipper", value: "broken zipper" },
                { label: "seam separation", value: "seam separation" },
                { label: "loss of resiliency", value: "loss of resiliency" },
                { label: "Laundry damage", value: "Laundry damage" },
                { label: "General soiling", value: "General soiling" },
                { label: "Box Springs", value: "Box Springs" },
              ]}
            />
          )}
          <RadioInput
            control={control}
            name="damageInfo.mattress_stained_damaged"
            required
            // shouldUnregister
            label="Mattress Stained/Damaged"
            options={["Yes", "No"]}
          />
          {mattress_stained_damaged?.toLowerCase() === "yes" && (
            <>
              <SelectField
                control={control}
                name="damageInfo.type_of_stain_damage"
                required
                // shouldUnregister
                label="Type of Mattress Stain/Damage"
                options={[
                  { label: "bed bugs", value: "bed bugs" },
                  { label: "beverage", value: "beverage" },
                  { label: "blood", value: "blood" },
                  {
                    label: "bodily fluid or feces",
                    value: "bodily fluid or feces",
                  },
                  { label: "bunching", value: "bunching" },
                  { label: "burn", value: "burn" },
                  {
                    label: "does not fit properly",
                    value: "does not fit properly",
                  },
                  { label: "feces", value: "feces" },
                  { label: "flaking", value: "flaking" },
                  { label: "food", value: "food" },
                  { label: "grease", value: "grease" },
                  { label: "gum", value: "gum" },
                  { label: "ink", value: "ink" },
                  { label: "melted", value: "melted" },
                  { label: "mildew", value: "mildew" },
                  { label: "mold", value: "mold" },
                  { label: "nail polish", value: "nail polish" },
                  { label: "not cooling", value: "not cooling" },
                  { label: "Peeling", value: "Peeling" },
                  { label: "pet damage", value: "pet damage" },
                  { label: "piling", value: "piling" },
                  { label: "Rip or Tear", value: "Rip or Tear" },
                  { label: "unknown stain", value: "unknown stain" },
                  { label: "water", value: "water" },
                  { label: "wearing", value: "wearing" },
                  { label: "wine", value: "wine" },
                  { label: "bleach", value: "bleach" },
                  { label: "broken zipper", value: "broken zipper" },
                  { label: "seam separation", value: "seam separation" },
                  { label: "loss of resiliency", value: "loss of resiliency" },
                  { label: "Laundry damage", value: "Laundry damage" },
                  { label: "General soiling", value: "General soiling" },
                  { label: "Box Springs", value: "Box Springs" },
                ]}
              />
              <PriceInput
                control={control}
                name="damageInfo.estimated_retail_value"
                // shouldUnregister
                required
                label="Estimated Mattress Retail Value (USD)"
              />
              <InputText
                control={control}
                name="damageInfo.mattress_manufacturer"
                required
                label="Mattress Manufacturer"
              />
              <InputText
                control={control}
                name="damageInfo.mattress_model"
                required
                label="Mattress Model"
              />
              <SelectField
                control={control}
                name="damageInfo.mattress_product"
                required
                label="Mattress Size"
                options={[
                  { label: "Cal. King", value: "Cal. King" },
                  { label: "Full", value: "Full" },
                  { label: "King", value: "King" },
                  { label: "Queen", value: "Queen" },
                  { label: "Twin", value: "Twin" },
                  { label: "Twin XL", value: "Twin XL" },
                ]}
              />
              <RadioInput
                control={control}
                label="Was the Protector/Encasement on bed during incident?"
                required
                // shouldUnregister
                name="damageInfo.protector_on_bed"
                options={["Yes", "No"]}
              />
            </>
          )}
        </div>
      )}
      <SelectField
        required
        control={control}
        label="Product Size"
        name="damageInfo.product_size"
        options={[
          { label: "Cal. King", value: "Cal. King" },
          { label: "Full", value: "Full" },
          { label: "Full XL", value: "Full XL" },
          { label: "King", value: "King" },
          { label: "Oly. Queen", value: "Oly. Queen" },
          { label: "Queen", value: "Queen" },
          { label: "Standard", value: "Standard" },
          { label: "Twin", value: "Twin" },
          { label: "Twin XL", value: "Twin XL" },
          { label: "Other", value: "Other" },
        ]}
      />
      <InputTextArea
        label={"Damage Notes"}
        control={control}
        name={"damageInfo.damageNotes"}
        required
      />
    </div>
  );
}

export default DamageDetails;
